// 减少接口的触发采取的行动

const state = {
  installedCapacity: ''
}
const getters = {
  installedCapacity: state => state.installedCapacity
}
const actions = {
  GetStructure ({commit}, data) {
    return commit('SetinstalledCapacity', data)
  }
}
const mutations = {
  SetinstalledCapacity: (state, installedCapacity) => {
    state.installedCapacity = installedCapacity
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/fixedMessage.js